import { makeMapFromListOfObjectsAndKeyToProperty } from "globals/helpers/helpers";
import { DropdownOption } from "globals/store/programs.data";

export const CURRENCY_OPTIONS: DropdownOption[] = [
  {id: "AFN",title:"Afghanistan Afghanis – AFN"},
  {id: "ALL",title:"Albania Leke – ALL"},
  {id: "DZD",title:"Algeria Dinars – DZD"},
  {id: "ARS",title:"Argentina Pesos – ARS"},
  {id: "AUD",title:"Australia Dollars – AUD"},
  {id: "ATS",title:"Austria Schillings – ATS"},
  {id: "BSD",title:"Bahamas Dollars – BSD"},
  {id: "BHD",title:"Bahrain Dinars – BHD"},
  {id: "BDT",title:"Bangladesh Taka – BDT"},
  {id: "BBD",title:"Barbados Dollars – BBD"},
  {id: "BEF",title:"Belgium Francs – BEF"},
  {id: "BMD",title:"Bermuda Dollars – BMD"},
  {id: "BRL",title:"Brazil Reais – BRL"},
  {id: "BGN",title:"Bulgaria Leva – BGN"},
  {id: "CAD",title:"Canada Dollars – CAD"},
  {id: "XOF",title:"CFA BCEAO Francs – XOF"},
  {id: "XAF",title:"CFA BEAC Francs – XAF"},
  {id: "CLP",title:"Chile Pesos – CLP"},
  {id: "CNY",title:"China Yuan Renminbi – CNY"},
  {id: "COP",title:"Colombia Pesos – COP"},
  {id: "XPF",title:"CFP Francs – XPF"},
  {id: "CRC",title:"Costa Rica Colones – CRC"},
  {id: "HRK",title:"Croatia Kuna – HRK"},
  {id: "CYP",title:"Cyprus Pounds – CYP"},
  {id: "CZK",title:"Czech Republic Koruny – CZK"},
  {id: "DKK",title:"Denmark Kroner – DKK"},
  {id: "DEM",title:"Deutsche (Germany) Marks – DEM"},
  {id: "DOP",title:"Dominican Republic Pesos – DOP"},
  {id: "NLG",title:"Dutch (Netherlands) Guilders - NLG"},
  {id: "XCD",title:"Eastern Caribbean Dollars – XCD"},
  {id: "EGP",title:"Egypt Pounds – EGP"},
  {id: "EEK",title:"Estonia Krooni – EEK"},
  {id: "EUR",title:"Euro – EUR"},
  {id: "FJD",title:"Fiji Dollars – FJD"},
  {id: "FIM",title:"Finland Markkaa – FIM"},
  {id: "FRF",title:"France Francs – FRF"},
  {id: "DEM",title:"Germany Deutsche Marks – DEM"},
  {id: "XAU",title:"Gold Ounces – XAU"},
  {id: "GRD",title:"Greece Drachmae – GRD"},
  {id: "GTQ",title:"Guatemalan Quetzal – GTQ"},
  {id: "NLG",title:"Holland (Netherlands) Guilders – NLG"},
  {id: "HKD",title:"Hong Kong Dollars – HKD"},
  {id: "HUF",title:"Hungary Forint – HUF"},
  {id: "ISK",title:"Iceland Kronur – ISK"},
  {id: "XDR",title:"IMF Special Drawing Right – XDR"},
  {id: "INR",title:"India Rupees – INR"},
  {id: "IDR",title:"Indonesia Rupiahs – IDR"},
  {id: "IRR",title:"Iran Rials – IRR"},
  {id: "IQD",title:"Iraq Dinars – IQD"},
  {id: "IEP",title:"Ireland Pounds – IEP"},
  {id: "ILS",title:"Israel New Shekels – ILS"},
  {id: "ITL",title:"Italy Lire – ITL"},
  {id: "JMD",title:"Jamaica Dollars – JMD"},
  {id: "JPY",title:"Japan Yen – JPY"},
  {id: "JOD",title:"Jordan Dinars – JOD"},
  {id: "KES",title:"Kenya Shillings – KES"},
  {id: "KRW",title:"Korea (South) Won – KRW"},
  {id: "KWD",title:"Kuwait Dinars – KWD"},
  {id: "LBP",title:"Lebanon Pounds – LBP"},
  {id: "LUF",title:"Luxembourg Francs – LUF"},
  {id: "MYR",title:"Malaysia Ringgits – MYR"},
  {id: "MTL",title:"Malta Liri – MTL"},
  {id: "MUR",title:"Mauritius Rupees – MUR"},
  {id: "MXN",title:"Mexico Pesos – MXN"},
  {id: "MAD",title:"Morocco Dirhams – MAD"},
  {id: "NLG",title:"Netherlands Guilders – NLG"},
  {id: "NZD",title:"New Zealand Dollars – NZD"},
  {id: "NOK",title:"Norway Kroner – NOK"},
  {id: "OMR",title:"Oman Rials – OMR"},
  {id: "PKR",title:"Pakistan Rupees – PKR"},
  {id: "XPD",title:"Palladium Ounces – XPD"},
  {id: "PEN",title:"Peru Nuevos Soles – PEN"},
  {id: "PHP",title:"Philippines Pesos – PHP"},
  {id: "XPT",title:"Platinum Ounces – XPT"},
  {id: "PLN",title:"Poland Zlotych – PLN"},
  {id: "PTE",title:"Portugal Escudos – PTE"},
  {id: "QAR",title:"Qatar Riyals – QAR"},
  {id: "RON",title:"Romania New Lei – RON"},
  {id: "ROL",title:"Romania Lei – ROL"},
  {id: "RUB",title:"Russia Rubles – RUB"},
  {id: "SAR",title:"Saudi Arabia Riyals – SAR"},
  {id: "XAG",title:"Silver Ounces – XAG"},
  {id: "SGD",title:"Singapore Dollars – SGD"},
  {id: "SKK",title:"Slovakia Koruny – SKK"},
  {id: "SIT",title:"Slovenia Tolars – SIT"},
  {id: "ZAR",title:"South Africa Rand – ZAR"},
  {id: "KRW",title:"South Korea Won – KRW"},
  {id: "ESP",title:"Spain Pesetas – ESP"},
  {id: "XDR",title:"Special Drawing Rights (IMF) – XDR"},
  {id: "LKR",title:"Sri Lanka Rupees – LKR"},
  {id: "SDD",title:"Sudan Dinars – SDD"},
  {id: "SEK",title:"Sweden Kronor – SEK"},
  {id: "CHF",title:"Switzerland Francs – CHF"},
  {id: "TWD",title:"Taiwan New Dollars – TWD"},
  {id: "THB",title:"Thailand Baht – THB"},
  {id: "TTD",title:"Trinidad and Tobago Dollars – TTD"},
  {id: "TND",title:"Tunisia Dinars – TND"},
  {id: "TRY",title:"Turkey New Lira – TRY"},
  {id: "AED",title:"United Arab Emirates Dirhams – AED"},
  {id: "GBP",title:"United Kingdom Pounds – GBP"},
  {id: "USD",title:"United States Dollars – USD"},
  {id: "VEB",title:"Venezuela Bolivares – VEB"},
  {id: "VND",title:"Vietnam Dong – VND"},
  {id: "ZMK",title:"Zambia Kwacha – ZMK"}
]

export const currencyNamesById = makeMapFromListOfObjectsAndKeyToProperty(CURRENCY_OPTIONS, 'id', 'title')